// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__1glws","bigColWidth":"Table_bigColWidth__2FLjV","biggerColWidth":"Table_biggerColWidth__2oWLH","row":"Table_row__6ogrX","col":"Table_col__1CC9s"};